export default __webpack_public_path__ + "img/filter_DP.296c2afb58764efa41ebdd546927d147.jpg";